import { connect } from 'react-redux';
import { get, intersection } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';
import { OtherShippingOptionsService } from '../../../services/other-shipping-options/other-shipping-options-service';
import { BulkEditOtherShippingOptions } from '../../../components/bulk-edit-other-shipping-options';

const mapStateToProps = (state, props) => {
  const { services, shippingConfiguration, onChange } = props;
  const matchingSellerServices = services;
  const hasMultipleCarriers = matchingSellerServices.some(
    (service) => service.labelProviderId !== matchingSellerServices[0].labelProviderId,
  );
  const serviceOptionCodes = matchingSellerServices.map((service) => service.optionCodes);
  const serviceCodeIntersection = [...intersection(...serviceOptionCodes), ...OtherShippingOptionsService.getDefaultOptions()];
  const optionData = OtherShippingOptionsService.buildOptions(serviceCodeIntersection, get(shippingConfiguration, 'options', emptyObject));

  return {
    saveOptions: (_, options) => {
      onChange(options.options);
    },
    optionData,
    hasMultipleCarriers,
    labelProviderId: matchingSellerServices.length > 0 ? matchingSellerServices[0].labelProviderId : '0',
    sellerLabelProviderId: matchingSellerServices[0]?.sellerLabelProviderId,
  };
};

export const BulkEditOtherShippingOptionsContainer = connect(mapStateToProps)(BulkEditOtherShippingOptions);
